/* Polyfill minimi per Safari iOS < 15.4 (Object.hasOwn, Array.prototype.at, String.replaceAll, structuredClone) */
if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", { value: (o, k) => Object.prototype.hasOwnProperty.call(Object(o), k), configurable: true, writable: true });
}
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, "at", { value: function (n) { n = Math.trunc(n) || 0; if (n < 0) n += this.length; return n < 0 || n >= this.length ? undefined : this[n]; }, configurable: true, writable: true });
}
if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, "replaceAll", { value: function (s, r) { return this.split(s).join(typeof r === "function" ? r(s) : r); }, configurable: true, writable: true });
}
if (typeof window !== "undefined" && !window.structuredClone) {
  window.structuredClone = (v) => JSON.parse(JSON.stringify(v));
}
if (typeof window !== "undefined" && !window.queueMicrotask) {
  window.queueMicrotask = (cb) => Promise.resolve().then(cb);
}
